import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isToday from 'dayjs/plugin/isToday';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

export const createDate = (date, format) => {
  if (format && date) {
    dayjs.extend(customParseFormat);
    return dayjs(date, format);
  }
  if (date) {
    return dayjs(date);
  }
  return dayjs();
};

export const getMonthFromString = mon => {
  const d = Date.parse(`${mon} 1, 2012`);
  if (!Number.isNaN(d)) {
    return new Date(d).getMonth() + 1;
  }
  return -1;
};

export const getCurrentDateTime = () => {
  dayjs.extend(utc);
  return dayjs.utc().format();
};

export const guessTimezone = () => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  return dayjs.tz.guess();
};

export const sortTimes = timeList => {
  if (timeList?.length === 1) {
    return timeList;
  }

  return timeList?.sort((a, b) => {
    const aTime = getNumericParts(a?.time);
    const bTime = getNumericParts(b?.time);

    return aTime?.[0] - bTime?.[0] || aTime?.[1] - bTime?.[1];
  });

  function getNumericParts(t) {
    return t?.split(':')?.map(x => +x);
  }
};

/**
 * Convert API api hh:mm:ss to hh:mm
 *
 * @param timeString
 * @returns {string}
 */
export const convertTimeStringToTimePicker = timeString => {
  if (typeof timeString === 'string') {
    return timeString.slice(0, 5);
  }
  return '';
};

export const isDateToday = date => {
  dayjs.extend(isToday);
  return date.isToday();
};

export const getTimestampForDisplay = (date, format) => {
  dayjs.extend(advancedFormat);

  return date.format(format);
};

export const createDatewithTz = (date, tz) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  if (tz) {
    try {
      return dayjs(date).tz(tz);
    } catch (err) {
      return dayjs(date);
    }
  }

  return dayjs(date);
};
